<template>
  <div>
    <div class="m-b-5">
      <nuxt-link
          class="button is-primary"
          :to="localePath('office-reclamations-id')"
        >
        <i class="mdi mdi-chevron-left"></i>
        </nuxt-link>
    </div>
    <h4 class="title is-4">{{ $t('form.create_info') }}</h4>
    <form @submit.prevent="onSubmit">
      <field-input
        :value.sync="author"
        name="author"
        required
        :label="`${$t('form.author')}:`"
        :vvas="$t('form.author')"
      />
      <field-textarea
        :value.sync="content"
        name="content"
        :label="`${$t('form.description')}:`"
        :vvas="$t('form.description')"
      />

      <div class="field m-t-5">
        <div class="control is-clearfix">
          <button
            class="button is-primary is-pulled-right"
            :class="{ 'is-loading': formLoading }"
          >{{ $t("form.submit") }}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      author: null,
      content: null,
      formLoading: false
    };
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      const request = {
        author: this.author,
        content: this.content,
        reclamation_id: this.$route.params.id
      };

      try {
        const { data } = await this.$api.createReclamationInfo(request);

        await this.$store.dispatch('reclamations/setActiveReclamation', this.$route.params.id);

        this.$toast.success(data.message);

        this.$router.push(this.localePath("office-reclamations-id"));
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/nuxt/pages/office/reclamations/_id/create-info.vue